import {Context} from '@gongxigames/framework/core/fragments/BuilderX/types';
import {Component, ComponentProps} from './Component';
import {MovieClip as MovieClipConstructor} from '@gongxigames/framework/core/fragments/display';
import {Sprite} from 'pixi.js';

export type MovieClipProps = ComponentProps;

export class MovieClip extends Component<MovieClipProps, MovieClipConstructor> {
    public readonly jsxType: string = 'movieclip';

    public propsToJson(): any {
        const result = super.propsToJson();

        result.frames = result.children;
        delete result.children;

        return result;
    }

    public clone(): MovieClip {
        return new MovieClip(this.props);
    }

    public getConstructor(): new () => any {
        return MovieClipConstructor;
    }

    public getChildrenToPixi(): Component<ComponentProps>[] {
        return [];
    }

    public updateBaseProps(context: Context, container: MovieClipConstructor, element: MovieClipConstructor): void {
        const props = this.props;

        if (!props.children) {
            throw new Error('MovieClip should contain children');
        }

        const children = props.children as any as Component<ComponentProps>[];
        const oldFrames = [...container.children];

        container.removeChildren();

        const frames = children.map((item, i) => {
            const oldChild = oldFrames[i] as Sprite;
            const constructor = this.getConstructor();

            if (container instanceof constructor) {
                return item.build({context, element: oldChild});
            }

            return item.build({context});
        }) as Sprite[];

        container.setFrames(frames);

        super.updateBaseProps(context, container, element);
    }
}
